/*
  Empty bag recommendations (snippets/rx-empty-cart.liquid). Loaded lazily and only when an empty bag is actually shown,
  so opening the cart never waits for it.
  Order: valid recently viewed products ("Recently Viewed"), else Georgia's Picks ("Selected by Georgia"),
  else New Arrivals ("Discover New Arrivals"). Cards are the shared product card, returned by the alternate views
  templates/product.rx-card.liquid and templates/collection.rx-recs.liquid, which already skip unavailable,
  gift-card and payment / deposit products. Nothing is invented: no history => a curated list, labelled as such.
*/
(function () {
  if (window.__rxEmptyRecs) return;
  window.__rxEmptyRecs = true;

  var MIN_RECENT = 2;
  var MAX_CARDS = 8;
  var assetBase = null;

  function readRecent() {
    var m = document.cookie.match(/(?:^|; )shopify_recently_viewed=([^;]*)/);
    if (!m) return [];
    var v = decodeURIComponent(m[1]).trim();
    return v ? v.split(' ').filter(Boolean) : [];
  }

  function getText(url) {
    return fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .catch(function () { return ''; })
      .then(function (t) { return (t || '').trim(); });
  }

  function splitSlides(html) {
    var box = document.createElement('div');
    box.innerHTML = html;
    return Array.prototype.slice.call(box.querySelectorAll('[data-rx-slide]'));
  }

  function fromRecent() {
    var handles = readRecent().slice(0, 12);
    return Promise.all(handles.map(function (h) {
      return getText('/products/' + encodeURIComponent(h) + '?view=rx-card');
    })).then(function (parts) {
      var slides = [];
      parts.forEach(function (p) { if (p) slides = slides.concat(splitSlides(p)); });
      return slides.slice(0, MAX_CARDS);
    });
  }

  function fromCollection(handle) {
    return getText('/collections/' + handle + '?view=rx-recs').then(splitSlides);
  }

  function ensureAssets(cb) {
    if (!assetBase) {
      var s = document.querySelector('script[src*="redeluxe-empty-cart.js"]');
      assetBase = s ? s.src.replace(/redeluxe-empty-cart\.js.*$/, '') : '/cdn/shop/t/78/assets/';
    }
    if (!document.querySelector('link[href*="redeluxe-product-carousel.css"]')) {
      var l = document.createElement('link');
      l.rel = 'stylesheet';
      l.href = assetBase + 'redeluxe-product-carousel.css';
      document.head.appendChild(l);
    }
    if (window.rxCarousel) { cb(); return; }
    var js = document.createElement('script');
    js.src = assetBase + 'redeluxe-product-carousel.js';
    js.onload = cb;
    js.onerror = cb;
    document.head.appendChild(js);
  }

  function render(box, label, slides) {
    var body = box.querySelector('[data-rx-recs-body]');
    var title = box.querySelector('[data-rx-recs-title]');
    if (!body || !slides.length) { box.hidden = true; return; }
    title.textContent = label;
    var section = document.createElement('section');
    section.className = 'rx-carousel';
    section.setAttribute('data-rx-carousel', '');
    section.style.setProperty('--rx-bg', 'transparent');
    section.style.setProperty('--rx-text', 'inherit');
    var inner = document.createElement('div');
    inner.className = 'rx-carousel__inner';
    var track = document.createElement('div');
    track.className = 'rx-carousel__track';
    track.setAttribute('data-rx-track', '');
    track.tabIndex = 0;
    track.setAttribute('role', 'region');
    track.setAttribute('aria-label', label);
    slides.forEach(function (s) {
      // Full names are cut to two lines by CSS here; keep the card's own title script (chevron + JS cut) out of it.
      var titles = s.querySelectorAll('[data-title]');
      for (var i = 0; i < titles.length; i++) titles[i].removeAttribute('data-title');
      track.appendChild(s);
    });
    inner.appendChild(track);
    inner.insertAdjacentHTML('beforeend',
      '<div class="rx-carousel__footer">' +
        '<div class="rx-carousel__progress" aria-hidden="true"><span class="rx-carousel__progress-bar" data-rx-bar></span></div>' +
        '<div class="rx-carousel__arrows">' +
          '<button type="button" class="rx-carousel__arrow" data-rx-prev aria-label="Previous products"><svg width="8" height="12" viewBox="0 0 8 12" fill="none" aria-hidden="true"><path d="M6.5 1L1.5 6l5 5" stroke="currentColor" stroke-width="1"/></svg></button>' +
          '<button type="button" class="rx-carousel__arrow" data-rx-next aria-label="Next products"><svg width="8" height="12" viewBox="0 0 8 12" fill="none" aria-hidden="true"><path d="M1.5 1l5 5-5 5" stroke="currentColor" stroke-width="1"/></svg></button>' +
        '</div>' +
      '</div>');
    section.appendChild(inner);
    body.textContent = '';
    body.appendChild(section);
    box.hidden = false;
    ensureAssets(function () {
      if (window.rxCarousel) window.rxCarousel.init(section);
    });
  }

  function load(box) {
    if (box.__rxState) return;
    box.__rxState = 'loading';
    fromRecent().then(function (recent) {
      if (recent.length >= MIN_RECENT) return { label: 'Recently Viewed', slides: recent };
      return fromCollection('georgias-picks').then(function (picks) {
        if (picks.length >= MIN_RECENT) return { label: 'Selected by Georgia', slides: picks };
        return fromCollection('products').then(function (fresh) {
          return fresh.length ? { label: 'Discover New Arrivals', slides: fresh } : null;
        });
      });
    }).then(function (result) {
      box.__rxState = 'done';
      if (!result) { box.hidden = true; return; }
      render(box, result.label, result.slides);
    }).catch(function () { box.__rxState = 'done'; box.hidden = true; });
  }

  function watch(box) {
    if (box.__rxWatched) return;
    box.__rxWatched = true;
    // The box is only laid out (and, in the drawer, slid into view) when an empty bag is really showing.
    var wrapper = box.closest('[data-cart-empty]');
    var start = function () {
      if (box.__rxState) return;
      if (window.requestIdleCallback) window.requestIdleCallback(function () { load(box); }, { timeout: 1500 });
      else window.setTimeout(function () { load(box); }, 200);
    };
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          start();
          io.disconnect();
        });
      });
      // The recommendations box itself is hidden until filled; observe the empty-state wrapper's title instead.
      io.observe(wrapper && wrapper.querySelector('.rx-empty__cta') ? wrapper.querySelector('.rx-empty__cta') : box);
    } else {
      start();
    }
  }

  function init() {
    var boxes = document.querySelectorAll('[data-rx-recs]');
    for (var i = 0; i < boxes.length; i++) watch(boxes[i]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
